import { WorkflowPhoneVerification } from "../components/workflowPhone/WorkflowPhoneVerification";

export function WorkflowPhonePage() {
  return <WorkflowPhoneVerification />;
}
